export function formatTranscriptSource(source: string | null | undefined): string {
  switch (source) {
    case 'youtubei': {
      return ' (YouTube API)';
    }
    case 'captionTracks': {
      return ' (Caption track fallback)';
    }
    case 'embedded': {
      return ' (Embedded transcript)';
    }
    case 'yt-dlp': {
      return ' (yt-dlp fallback)';
    }
    case 'youtube-media': {
      return ' (YouTube media transcription)';
    }
    case 'apify': {
      return ' (Apify fallback)';
    }
    case 'html': {
      return ' (HTML fallback)';
    }
    case 'whisper': {
      return ' (Whisper fallback)';
    }
    case 'podcastTranscript': {
      return ' (Podcast transcript)';
    }
    case 'unavailable': {
      return ' (Transcript unavailable)';
    }
    case 'unknown': {
      return ' (Unknown transcript source)';
    }
    case null:
    case undefined: {
      return '';
    }
    default: {
      return '';
    }
  }
}

export function formatQuantity(value: number): string {
  if (!Number.isFinite(value)) return '—';
  if (value >= 1_000_000) {
    const millions = value / 1_000_000;
    if (millions >= 100) {
      return `${Math.round(millions)}M`;
    }
    const formatted = millions.toFixed(1);
    return formatted.endsWith('.0') ? `${formatted.slice(0, -2)}M` : `${formatted}M`;
  }
  if (value >= 1000) {
    const thousands = value / 1000;
    if (thousands >= 100) {
      return `${Math.round(thousands)}K`;
    }
    const formatted = thousands.toFixed(1);
    return formatted.endsWith('.0') ? `${formatted.slice(0, -2)}K` : `${formatted}K`;
  }
  return value.toLocaleString();
}

export function formatCostValue(usd: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(usd);
}

export function formatCostDisplay(cents: number, fallbackUsd?: number | null) {
  if (cents > 0) {
    return { display: formatCostValue(cents / 100), hasValue: true } as const;
  }
  if (fallbackUsd && fallbackUsd > 0) {
    return {
      display: fallbackUsd < 0.0001 ? '<$0.0001' : formatCostValue(fallbackUsd),
      hasValue: true,
    } as const;
  }
  return { display: '$0.00', hasValue: false } as const;
}
